import { DeleteOutlineIcon } from '@carboncopyco/icons';
import type { IDynamicEditData } from '@carboncopyco/types';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { ModificationItem } from './ModificationItem';
import { getDeleteLabel } from './utils';

export const DeleteModificationItem = ({
  edit,
  id,
}: {
  edit: IDynamicEditData['element'];
  id: string;
}) => {
  const flags = useFlags();
  const label = getDeleteLabel(edit);
  return (
    <ModificationItem>
      <ModificationItem.Content>
        <ModificationItem.Icon>
          <DeleteOutlineIcon size={18} />
        </ModificationItem.Icon>
        <ModificationItem.Text
          label={label}
          tooltipLabel={
            flags.editorSpotManagerDebugMode ? `${label} (${id})` : label
          }
        />
      </ModificationItem.Content>
    </ModificationItem>
  );
};
